import { Cell } from '@/grid/Cell';

export type HeuristicFunction = (cellA: Cell, cellB: Cell) => number;

export class Heuristic {
  static manhattan(cellA: Cell, cellB: Cell): number {
    return Math.abs(cellA.row - cellB.row) + Math.abs(cellA.col - cellB.col);
  }

  static euclidean(cellA: Cell, cellB: Cell): number {
    const dx = cellA.row - cellB.row;
    const dy = cellA.col - cellB.col;
    return Math.sqrt(dx * dx + dy * dy);
  }

  static chebyshev(cellA: Cell, cellB: Cell): number {
    return Math.max(Math.abs(cellA.row - cellB.row), Math.abs(cellA.col - cellB.col));
  }

  static octile(cellA: Cell, cellB: Cell): number {
    const dx = Math.abs(cellA.row - cellB.row);
    const dy = Math.abs(cellA.col - cellB.col);
    return Math.max(dx, dy) + (Math.SQRT2 - 1) * Math.min(dx, dy);
  }

  static zero(): number {
    return 0;
  }
}
